import { render, staticRenderFns } from "./IconDotsVerticalOutline.vue?vue&type=template&id=185a1446"
import script from "./IconDotsVerticalOutline.vue?vue&type=script&lang=js"
export * from "./IconDotsVerticalOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports